import axios  from 'axios';
import { Config }   from './configActions';
var Authorization = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");
Config();
export const FETCH_ALL_TAREFAS_PROFESSOR         = 'FETCH_ALL_TAREFAS_PROFESSOR';
export const FETCH_ALL_CURSO_COORDENADOR         = 'FETCH_ALL_CURSO_COORDENADOR';
export const FETCH_ALL_TURMA_PROFESSOR           = 'FETCH_ALL_TURMA_PROFESSOR';
export const FETCH_ALL_ALUNOS_DESEMPENHO_TAREFAS = 'FETCH_ALL_ALUNOS_DESEMPENHO_TAREFAS';
export const REMOVER_TAREFA                      = 'REMOVER_TAREFA';
export const SET_NOTA_ALUNO_DESEMPENHO           = 'SET_NOTA_ALUNO_DESEMPENHO';
export const FETCH_ALL_DISCIPLINAS_TAREFAS_PROFESSOR = 'FETCH_ALL_DISCIPLINAS_TAREFAS_PROFESSOR';
export const FETCH_ALL_TAREFAS_ALUNO = 'FETCH_ALL_TAREFAS_ALUNO';
export const FETCH_ALL_COMPONENTES               = 'FETCH_ALL_COMPONENTES';

export function GetTarefasPerfil(dis_id,tur_id) {

	//const id = (cur_id?`/${cur_id}`:"");

    const request =  axios.get(`/api/tarefas/disciplina/listar/${dis_id}/${tur_id}`, Authorization);
    return{
        type    : FETCH_ALL_TAREFAS_PROFESSOR,
        payload : request

    };
}

export function GetDisciplinasPerfil(use_id) {

	//const id = (cur_id?`/${cur_id}`:"");

	const request =  axios.get(`/api/disciplinas/professor/${use_id}`, Authorization);
	return{
		type    : FETCH_ALL_DISCIPLINAS_TAREFAS_PROFESSOR,
		payload : request

	};
}

export function GetTarefasAluno(tur_id) {

	//const id = (cur_id?`/${cur_id}`:"");

	const request =  axios.get(`/api/tarefas/listar/${tur_id}`, Authorization);
	return{
		type    : FETCH_ALL_TAREFAS_ALUNO,
		payload : request

	};
}

export function GetCursoCoordenador(use_id) {

	const request =  axios.get(`/api/tarefas/listar/cursos/coordenador/${use_id}`, Authorization);
	return{
		type    : FETCH_ALL_CURSO_COORDENADOR,
		payload : request

	};
}

export function GetTurmasCoordenador(use_id,tur_id) {

	const request = axios.get(`/api/turmas/listar/coordenador/${use_id}/${tur_id}`, Authorization);
	return{
		type    : FETCH_ALL_TURMA_PROFESSOR,
		payload : request
	};
}

export function GetTarefasTurmasAlunos(tur_id,tar_id) {

	const request =  axios.get(`/api/tarefas/listar/alunos/${tur_id}/${tar_id}`, Authorization);
	return{
		type    : FETCH_ALL_ALUNOS_DESEMPENHO_TAREFAS,
		payload : request
	};
}

export function GetComponentesTarefas(tar_id) {

	const request =  axios.get(`/api/tarefas/componentes/listar/${tar_id}`, Authorization);
	return{
		type    : FETCH_ALL_COMPONENTES,
		payload : request
	};				
}

export function GetTarefa(use_id,tar_id) {

	return dispatch => {
		return axios.get(`/api/tarefas/obter/${use_id}/${tar_id}`, Authorization);
	}
}

export function GetTarefasTurmas(tar_id) {

	return dispatch => {
    	return axios.get(`/api/tarefas/turmas/listar/${tar_id}`, Authorization)
	}
}

export function GetFeedBackTarefa(use_id,tar_id) {

	return dispatch => {
    	return axios.get(`/api/tarefas/feedback/${use_id}/${tar_id}`, Authorization)
	}
}

export function SetCadastroTarefas(retorno) {

	  return dispatch => {

		const formData = new FormData();
		formData.append('tar_titulo', retorno.tar_titulo);
		formData.append('tar_flag_resposta', retorno.tar_flag_resposta);
		formData.append('tar_descricao', retorno.tar_descricao);
		formData.append('tar_objetivo', retorno.tar_objetivo);
		formData.append('tar_txt_recompensa', retorno.tar_txt_recompensa);
		formData.append('tar_data_inicio', retorno.tar_data_inicio);
		formData.append('tar_data_fim', retorno.tar_data_fim);
		formData.append('tar_tipo_midia', retorno.tar_tipo_midia);
		formData.append('tar_midia', retorno.tar_midia);
		formData.append('tar_cod_usuario', retorno.tar_cod_usuario);
		formData.append('tar_id', retorno.tar_id);
		formData.append('tar_flag_entrega_equipe', retorno.tar_flag_entrega_equipe);
		formData.append('tar_cod_dis_tur',JSON.stringify(retorno.tar_cod_dis_tur));
		formData.append('tar_anexo',retorno.tar_anexo);

		return  axios.post('/api/tarefas/cadastrar', formData,Authorization);

	  }
}

export function SetEditarTarefas(retorno){

	return dispatch => {
	
		const formData = new FormData();
		formData.append('tar_titulo', retorno.tar_titulo);
		formData.append('tar_flag_resposta', retorno.tar_flag_resposta);
		formData.append('tar_descricao', retorno.tar_descricao);
		formData.append('tar_objetivo', retorno.tar_objetivo);
		formData.append('tar_txt_recompensa', retorno.tar_txt_recompensa);
		formData.append('tar_data_inicio', retorno.tar_data_inicio);
		formData.append('tar_data_fim', retorno.tar_data_fim);
		formData.append('tar_tipo_midia', parseInt(retorno.tar_tipo_midia));
		formData.append('tar_midia', retorno.tar_midia);
		formData.append('tar_cod_usuario', retorno.tar_cod_usuario);
		formData.append('tar_id', retorno.tar_id);
		formData.append('tar_cod_disciplina', retorno.tar_cod_disciplina);
		formData.append('tar_flag_entrega_equipe', retorno.tar_flag_entrega_equipe);
		formData.append('tar_cod_turma',JSON.stringify(retorno.tar_cod_turma));
		formData.append('tar_anexo', retorno.tar_anexo);
		return  axios.post('/api/tarefas/atualizar', formData,Authorization);

	 }
}

export function SetNotaTarefasTurmasAlunos(retorno) {

	const request=  axios.post('/api/tarefas/lancar/notas', {
		 						cur_id             : retorno.cur_id,
								ent_tar_cod_aluno  : retorno.ent_tar_cod_aluno,
		 						ent_tar_pontuacao  : retorno.ent_tar_pontuacao,
		 						ent_tar_cod_tarefa : retorno.ent_tar_cod_tarefa,
		 						ent_tar_feedback   : retorno.ent_tar_feedback,
		 		}, Authorization);
	return{
		type    : SET_NOTA_ALUNO_DESEMPENHO,
		payload : request

	};

}

export function SetUploadFiles(tar_id,file) {

    console.log(tar_id)
    console.log(file)

    tar_id = [tar_id];

	return dispatch => {
				
			return axios.all(
					tar_id.map((elem,i)=>{
					const formData = new FormData();
					formData.append('tar_anexo', file[0]);
					formData.append('tar_id', elem);
					return 	axios.post('/api/tarefas/uploadTarefa', formData, Authorization);
				
				})

			)
	}
}


export function SetUploadFilesMidia(tar_id,file) {

    tar_id = [tar_id];

    return dispatch => {

        return axios.all(
            tar_id.map((elem,i)=>{
                const formData = new FormData();
                formData.append('tar_midia', file[0]);
                formData.append('tar_id', elem);
                return 	axios.post('/api/tarefas/uploadTarefaMidia', formData, Authorization);

            })

        )
    }
}


export function SetRespondeTarefasUploadFiles(dados) {

	return dispatch => {
				if (dados.file) {
					const formData = new FormData();
					formData.append('ent_tar_anexo', dados.file);
					formData.append('ent_tar_cod_aluno', dados.use_id);
					formData.append('ent_tar_cod_tarefa', dados.tar_id);
					formData.append('ent_tar_cod_equipe', dados.tar_cod_equipe);
					formData.append('ent_tar_flag_entrega_equipe', dados.tar_flag_entrega_equipe);
					return axios.post('/api/tarefas/responder', formData, Authorization);		
					
				} else {

					return axios.post('/api/tarefas/responder', {
						ent_tar_anexo             : null,
					   ent_tar_cod_aluno  : dados.use_id,
						ent_tar_cod_tarefa : dados.tar_id,
						ent_tar_cod_equipe   : dados.tar_cod_equipe,
						ent_tar_flag_entrega_equipe   : dados.tar_flag_entrega_equipe,
					}, Authorization);
					
				}
				
	}

}

export function removerTarefa(id){
	
	axios.get(`/api/tarefas/deletar/${id}`,Authorization);
	return{
			type    : REMOVER_TAREFA,
			payload : id
		};  
}











// WEBPACK FOOTER //
// ./src/actions/tarefaAction.js